(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3161,7839],{

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js + 1 modules
var colorManipulator = __webpack_require__(8423);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js + 2 modules
var createSvgIcon = __webpack_require__(88169);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 6 modules
var ButtonBase = __webpack_require__(82607);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/BreadcrumbCollapsed.js








const BreadcrumbCollapsedButton = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(({
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': (0,esm_extends/* default */.Z)({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': (0,esm_extends/* default */.Z)({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = (0,styled/* default */.ZP)(MoreHoriz)({
  width: 24,
  height: 16
});
/**
 * @ignore - internal component.
 */

function BreadcrumbCollapsed(props) {
  const ownerState = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedButton, (0,esm_extends/* default */.Z)({
      focusRipple: true
    }, props, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedIcon, {
        ownerState: ownerState
      })
    }))
  });
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = (BreadcrumbCollapsed);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/breadcrumbsClasses.js

function getBreadcrumbsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0,generateUtilityClasses/* default */.Z)('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
/* harmony default export */ var Breadcrumbs_breadcrumbsClasses = (breadcrumbsClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js


const _excluded = ["children", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];













const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return (0,composeClasses/* default */.Z)(slots, getBreadcrumbsUtilityClass, classes);
};

const BreadcrumbsRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${Breadcrumbs_breadcrumbsClasses.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = (0,styled/* default */.ZP)('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = (0,styled/* default */.ZP)('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});

function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

const Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });

  const {
    children,
    className,
    component = 'nav',
    expandText = 'Show path',
    itemsAfterCollapse = 1,
    itemsBeforeCollapse = 1,
    maxItems = 8,
    separator = '/'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const [expanded, setExpanded] = react.useState(false);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });

  const classes = useUtilityClasses(ownerState);
  const listRef = react.useRef(null);

  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.

      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };

  const allItems = react.Children.toArray(children).filter(child => {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: (0,clsx_m["default"])(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

/***/ }),

/***/ 32538:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories",
      function () {
        return __webpack_require__(42962);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(18633);
;// CONCATENATED MODULE: ./src/utils/filter-breadcrumbs.ts

function filterBreadcrumbs(useCollectionCrumbs, data, locale, currentCollection) {
    var ref;
    var url = "".concat((ref = "https://fun.libero.it/") === null || ref === void 0 ? void 0 : ref.replace(/\/+$/, ""));
    var breadcrumbs = data;
    if (useCollectionCrumbs) {
        var filteredCrumbs = breadcrumbs.filter(function(crumb) {
            var ref;
            return !(crumb === null || crumb === void 0 ? void 0 : (ref = crumb.type) === null || ref === void 0 ? void 0 : ref.includes("category"));
        });
        if ((currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.name) && (currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.slug)) {
            return filteredCrumbs.map(function(crumb) {
                var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
                if (crumb.path.includes(translatedCollection)) {
                    return {
                        href: "".concat(url).concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        path: "".concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        name: currentCollection.name
                    };
                }
                return crumb;
            });
        }
        return filteredCrumbs;
    } else {
        return breadcrumbs.filter(function(crumb) {
            var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
            return !crumb.path.includes(translatedCollection);
        });
    }
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx











var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "breadcrumb"
    ]).t;
    var breadcrumbFilter = props.breadcrumbs.map(function(breadcrumb) {
        return breadcrumb.path === "/" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, breadcrumb), {
            name: t("breadcrumb:home")
        }) : breadcrumb;
    });
    var currentCollection = appContext.useCollectionCrumbs().currentCollection;
    var ref = appContext.useConfig(), languageCode = ref.languageCode, componentOptions = ref.componentOptions;
    var breadcrumbs = filterBreadcrumbs(componentOptions.component_use_collection_crumbs || false, breadcrumbFilter, languageCode, currentCollection);
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 67839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CollectionSection": function() { return /* reexport */ CollectionSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/CollectionSection/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_collection_border_radius",
                label: "Border radius",
                type: "number",
                endAdornment: "px",
                default: theme.shape.borderRadius
            },
            {
                name: "theme_component_collection_background_color",
                label: "Background color",
                type: "color",
                default: "rgba(0, 0, 0, 0)"
            },
            {
                name: "theme_component_collection_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                default: 0,
                endAdornment: "px"
            },
            {
                name: "theme_component_collection_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
;// CONCATENATED MODULE: ./src/components/CollectionSection/CollectionSection.tsx








var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z, {
    target: "e7wqnia0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        borderRadius: theme.theme_component_collection_border_radius ? "".concat(theme.theme_component_collection_border_radius, "px") : theme.shape.borderRadius,
        backgroundColor: theme.theme_component_collection_background_color || "rgba(0, 0, 0, 0)",
        borderBottomWidth: theme.theme_component_collection_border_bottom_width ? "".concat(theme.theme_component_collection_border_bottom_width, "px") : 0,
        borderBottomColor: theme.theme_component_collection_border_bottom_color || theme.palette.divider,
        borderBottomStyle: "solid",
        "&:first-of-type": {
            marginTop: theme.spacing(0)
        },
        "&:last-of-type:not(:first-of-type)": {
            marginBottom: theme.spacing(0)
        }
    };
});
var CollectionSection = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useEditorHandlers("Collection Section"), other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/CollectionSection/index.ts



/***/ }),

/***/ 61546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ Title; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Title/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_title_color",
                label: "General text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_title_color",
                label: "Title text color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_title_link_hover_color",
                label: "Link text hover color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_title_link_active_color",
                label: "Link text active color",
                type: "color",
                default: theme.palette.action.active
            },
            {
                name: "theme_component_card_title_font_size",
                label: "Title font size",
                endAdornment: "px",
                type: "text",
                default: theme.typography.h2.fontSize
            },
            // 
            // {
            //   name: 'theme_component_title_padding',
            //   label: 'Padding',
            //   type: 'text',
            //   default: theme.spacing(1, 2),
            //   helperText: 'Define as top right left bottom; e.g.: 2px 10px 5px 10px',
            // },
            {
                name: "theme_component_title_lg_padding",
                label: "Padding for large screens",
                type: "text",
                default: theme.spacing(1, 2),
                helperText: "Define as top right left bottom; e.g.: 2px 10px 5px 10px"
            },
            // {
            //   name: 'theme_component_title_justify_content',
            //   label: 'Justify content',
            //   type: 'select',
            //   default: 'space-between',
            //   options: ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'],
            // },
            // {
            //   name: 'theme_component_title_align_items',
            //   label: 'Align items',
            //   type: 'select',
            //   default: 'center',
            //   options: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
            // },
            {
                name: "theme_component_title_border_bottom_width",
                label: "Border bottom width",
                type: "number",
                endAdornment: "px",
                default: 1
            },
            {
                name: "theme_component_title_border_bottom_color",
                label: "Border bottom color",
                type: "color",
                default: theme.palette.divider
            }, 
        ],
        configuration: []
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
;// CONCATENATED MODULE: ./src/components/Title/Title.tsx










var Title_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Container/* default */.Z, {
    target: "e15gjue10"
})(function(param) {
    var theme = param.theme;
    return {
        borderBottomWidth: theme.theme_component_title_border_bottom_width ? "".concat(theme.theme_component_title_border_bottom_width, "px") : 0,
        borderBottomStyle: "solid",
        borderBottomColor: theme.theme_component_title_border_bottom_color || theme.palette.divider,
        color: theme.theme_component_title_color || theme.palette.text.primary,
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        textTransform: "capitalize"
    };
});
var TypographyStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Title_Typography, {
    target: "e15gjue11"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        textTransform: "none",
        color: theme.theme_component_title_title_color || "inherit",
        "& > a": {
            color: theme.theme_component_title_title_color || theme.palette.text.primary,
            "&:hover": {
                color: theme.theme_component_title_link_hover_color || theme.palette.action.hover
            },
            "&:active": {
                color: theme.theme_component_title_link_active_color || theme.palette.action.active
            }
        }
    };
});
var Title = function(props) {
    var disableGutters = props.disableGutters, children = props.children, className = props.className, style = props.style, childStyle = props.childStyle, other = (0,_object_without_properties/* default */.Z)(props, [
        "disableGutters",
        "children",
        "className",
        "style",
        "childStyle"
    ]);
    var titleRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        maxWidth: false,
        disableGutters: disableGutters,
        className: className,
        style: style
    }, useEditorHandlers("Title")), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TypographyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: titleRef,
            style: childStyle
        }, other), {
            children: children
        }))
    }));
};

;// CONCATENATED MODULE: ./src/components/Title/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ }),

/***/ 42962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ CategoriesPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(42708);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./src/utils/ads-request.ts
var ads_request = __webpack_require__(18505);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/CollectionSection/index.ts + 2 modules
var CollectionSection = __webpack_require__(67839);
// EXTERNAL MODULE: ./src/components/Title/index.ts + 2 modules
var Title = __webpack_require__(61546);
// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 2 modules
var BreadCrumbs = __webpack_require__(70055);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(18714);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(15888);
// EXTERNAL MODULE: ./src/utils/useFlattenArray.ts
var useFlattenArray = __webpack_require__(86731);
;// CONCATENATED MODULE: ./src/containers/CollectionsA/CollectionsA.tsx
























var AdvertisementSlot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9371).then(__webpack_require__.bind(__webpack_require__, 29918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29918)
            ];
        }
    },
    ssr: false
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3818), __webpack_require__.e(4386), __webpack_require__.e(4821), __webpack_require__.e(4905), __webpack_require__.e(3503)]).then(__webpack_require__.bind(__webpack_require__, 24905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24905)
            ];
        }
    },
    ssr: false
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e709a2p0"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        paddingBottom: theme.spacing(2)
    };
});
var AdCollectionContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e709a2p1"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        background: "none",
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(4, 2)
    }, theme.breakpoints.down("xs"), {
        padding: theme.spacing(2, 0)
    });
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot, {
    target: "e709a2p2"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: "grey"
    };
});
var Ads = function(param) {
    var style = param.style, id = param.id, variant = param.variant;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdCollectionContainer, {
        style: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
            slotIdentifier: id || "idhb-middle-970",
            variant: variant
        })
    });
};
var CollectionsA = function(props) {
    var collections = props.collections, pageContext = props.pageContext;
    var t = (0,esm/* useTranslation */.$G)("collections_a").t;
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var ref = (0,react_intersection_observer/* useInView */.YD)(), ref1 = ref.ref, inView = ref.inView;
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var panel = (0,CursorContext/* useCursorContext */.r)().panel;
    var collectionsBeforeAdContainer = (collections === null || collections === void 0 ? void 0 : collections.filter(function(c) {
        return !c.code.includes("recommended");
    }).slice(0, Math.ceil(collections.length / 2))) || [];
    var collectionsAfterAdContainer = (collections === null || collections === void 0 ? void 0 : collections.length) > 1 ? (collections === null || collections === void 0 ? void 0 : collections.filter(function(c) {
        return !c.code.includes("recommended");
    }).slice(Math.ceil(collections.length / 2))) || [] : [];
    react.useEffect(function() {
        (0,ads_request.adsRequest)([
            "idhb-middle-970"
        ]);
    }, []);
    var cardType = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("lastplayed:current", []), 1), lastPlayedGames = ref2[0];
    var showLastPlayedCarousel = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_homepage_show_last_played_carousel;
    var recommendedCollection = collections.find(function(c) {
        return c.code.includes("recommended");
    }) || {
        games: []
    };
    var flattenedData = (0,useFlattenArray/* default */.Z)(lastPlayedGames || []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                maxWidth: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                    breadcrumbs: pageContext.breadcrumbs
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
                ref: ref1,
                children: [
                    showLastPlayedCarousel && flattenedData && flattenedData.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection.CollectionSection, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                component: "h2",
                                variant: "h2",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                    href: "/",
                                    title: t("my_last_played", "My Last Played"),
                                    underline: "hover",
                                    children: t("my_last_played", "My Last Played")
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                padding: theme.spacing(2),
                                items: (0,_to_consumable_array/* default */.Z)(flattenedData).concat((0,_to_consumable_array/* default */.Z)((recommendedCollection.games || []).map(function(game) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, game), {
                                        trend: true
                                    });
                                }))),
                                cardOptions: {
                                    width: componentOptions.component_card_width || 512,
                                    height: componentOptions.component_card_height || 288,
                                    sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                    layout: "responsive",
                                    template: cardType || types_enum/* CardTypeEnum.EXTENSIVE */.mq.EXTENSIVE,
                                    typographyOptions: {
                                        align: "left"
                                    }
                                }
                            })
                        ]
                    }, "last-played-section"),
                    collectionsBeforeAdContainer.map(function(collection, index) {
                        return collection.games.length > 0 && (inView || index === 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection.CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: index === 1 ? "h1" : "h2",
                                    variant: "h2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: "/".concat(collection.type, "/").concat(collection.slug),
                                        title: collection.name || undefined,
                                        underline: "hover",
                                        children: collection.name
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                    padding: theme.spacing(2),
                                    items: collection.games,
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        template: cardType || types_enum/* CardTypeEnum.EXTENSIVE */.mq.EXTENSIVE,
                                        typographyOptions: {
                                            align: "left"
                                        }
                                    }
                                })
                            ]
                        }, "".concat(collection.id).concat(index));
                    }),
                    panel && lg ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ads, {
                        id: componentOptions.component_center_ads_id,
                        style: {
                            paddingBottom: collectionsAfterAdContainer.length > 0 ? 0 : theme.spacing(4)
                        },
                        variant: "970x250"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: !componentOptions.component_ads_disabled && lg && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: !componentOptions.component_middle_a_ads_disable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ads, {
                                id: componentOptions.component_center_ads_id,
                                style: {
                                    paddingBottom: collectionsAfterAdContainer.length > 0 ? 0 : theme.spacing(4)
                                },
                                variant: "970x250"
                            })
                        })
                    }),
                    inView && collectionsAfterAdContainer.map(function(collection, index) {
                        return collection.games.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionSection.CollectionSection, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* Title */.D, {
                                    component: "h2",
                                    variant: "h2",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: "/".concat(collection.type, "/").concat(collection.slug),
                                        title: collection.name || undefined,
                                        underline: "hover",
                                        children: collection.name
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                                    padding: theme.spacing(2),
                                    items: collection.games,
                                    cardOptions: {
                                        width: componentOptions.component_card_width || 512,
                                        height: componentOptions.component_card_height || 288,
                                        sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                                        layout: "responsive",
                                        typographyOptions: {
                                            align: "left"
                                        }
                                    }
                                })
                            ]
                        }, "".concat(collection.id).concat(index));
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/CollectionsA/index.ts


;// CONCATENATED MODULE: ./src/generated/categories/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionsA, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 5 modules
var BaseLayout = __webpack_require__(92176);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
;// CONCATENATED MODULE: ./src/pages/categories.tsx





// import { CollectionsA as View } from '../containers/CollectionsA';






var __N_SSG = true;
function CategoriesPage(props) {
    var categories = props.categories, pageContext = props.pageContext;
    var ref = (0,esm/* useTranslation */.$G)([
        "common",
        "categories"
    ]), t = ref.t, i18n = ref.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref1 = appContext.useConfig(), name = ref1.name, assetAbsoluteUrl = ref1.assetAbsoluteUrl;
    var router = (0,next_router.useRouter)();
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContext), {
        paths: (0,localize_helpers/* getLocalizedPaths */.mT)(router),
        slugs: (0,localize_helpers/* getLocalizedSlugs */.fD)(router),
        slug: (0,localize_helpers/* cleanSlug */.Hm)(router.pathname)
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: i18n.exists("categories:title", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("categories:title") : t("common:title"),
                description: i18n.exists("categories:description", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("categories:description") : t("common:description")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* CollectionPageJsonLd */.yr, {
                name: t("common:title"),
                hasPart: categories.map(function(category) {
                    return {
                        about: category.description,
                        author: {
                            name: name
                        },
                        name: category.name,
                        audience: "Internet",
                        keywords: "schema",
                        thumbnailUrl: "".concat(assetAbsoluteUrl).concat(category.images.cover1x1 || category.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                        image: "".concat(assetAbsoluteUrl).concat(category.images.cover1x1 || category.images.cover, "/")
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                    return {
                        position: index + 1,
                        name: crumb.name,
                        item: crumb.href
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                collections: categories,
                title: i18n.exists("categories:headline", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("categories:headline") : t("common:headline"),
                body: i18n.exists("categories:body", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("categories:body") : t("common:body"),
                pageContext: pageContextWithPaths
            }))
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
CategoriesPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: "categories",
        pageContext: pageContext,
        children: page
    });
};


/***/ }),

/***/ 86731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useFlattenedGameData = function(initialData) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), flattenedData = ref[0], setFlattenedData = ref[1];
    // Veriyi düzleştiren fonksiyon
    var flattenData = function(data) {
        var flattenedArray = data.reduce(function(acc, curr) {
            if (Array.isArray(curr)) {
                var _acc;
                (_acc = acc).push.apply(_acc, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(curr));
            } else {
                acc.push(curr);
            }
            return acc;
        }, []);
        return flattenedArray;
    };
    // Başlangıçta veriyi düzleştir
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (initialData && initialData.length) {
            setFlattenedData(flattenData(initialData));
        }
    }, [
        initialData
    ]);
    return flattenedData;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFlattenedGameData);


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(69921);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2906,978,1074,3500,9774,2888,179], function() { return __webpack_exec__(32538); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);